import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import type { DailyMetrics } from "@/types/analytics.types";

interface DailyMetricsChartProps {
  metrics: DailyMetrics[];
}

export const DailyMetricsChart = ({ metrics }: DailyMetricsChartProps) => {
  const chartData = metrics.map(metric => ({
    datum: new Date(metric.date).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' }),
    Sitzungen: metric.sessions,
    Absprungrate: metric.bounceRate.toFixed(1),
    Conversions: metric.conversions,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Tägliche Entwicklung</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis 
              dataKey="datum" 
              className="text-xs"
              tick={{ fill: 'hsl(var(--foreground))' }}
            />
            <YAxis 
              className="text-xs"
              tick={{ fill: 'hsl(var(--foreground))' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--background))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="Sitzungen" 
              stroke="hsl(var(--primary))" 
              strokeWidth={2}
            />
            <Line 
              type="monotone" 
              dataKey="Conversions" 
              stroke="hsl(var(--accent))" 
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
